module.exports = __webpack_public_path__ + "img/InformationIBlack.f7c9b833.svg";